import React from "react";

const Card1 = ({qrCodeRef, logo, profile, candidateName, studentAdmission, studentClass, studentSection, qrData, fathersName, schoolName, mobile, schoolMobile, schoolAddress}) => {
  return (
    <div
      ref={qrCodeRef}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="id-card"
        style={{
          width: "350px",
          height: "auto",
          background: "#fff",
          borderRadius: "10px",
          padding: "5px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
          textAlign: "center",
          border: "2px solid green",
        }}
      >
        <div
          className="header"
          style={{
            color: "rgb(0, 0, 0)",
            padding: "10px",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={logo}
            alt="Profile"
            style={{
              width: 50,
              height: 50,
            }}
          />
          <h5 style={{ fontSize: "20px", fontWeight: "bold" }}>
            {schoolName}
          </h5>
        </div>
        <div
          className="photo"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <div className="student-photo">
            <img
              src={profile}
              alt="Profile"
              style={{
                width: 120,
                height: 120,
                objectFit: "cover",
              }}
            />
          </div>
        </div>
        <div
          className="info"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "left",
            width: "100%",
            padding: "15px",
            background: "#f8f8f8",
            borderRadius: "10px",
          }}
        >
          <h5
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              color: "#4CAF50",
              marginBottom: "12px",
              textAlign: "center",
              width: "100%",
            }}
          >
            {candidateName}
          </h5>
          <p
            style={{
              fontSize: "12px",
              margin: "5px 0",
              color: "rgb(102, 102, 102)",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <strong>Admission No.:</strong>
            {studentAdmission}
          </p>
          <p
            style={{
              fontSize: "12px",
              margin: "5px 0",
              color: "rgb(102, 102, 102)",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <strong>Father:</strong> {fathersName}
          </p>
          <p
            style={{
              fontSize: "12px",
              margin: "5px 0",
              color: "rgb(102, 102, 102)",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <strong>Class:</strong> {studentClass} - {studentSection}
          </p>
          {/* <p
            style={{
              fontSize: "12px",
              margin: "5px 0",
              color: "rgb(102, 102, 102)",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <strong>D.O.B:</strong> 28/03/2012
          </p> */}
          <p
            style={{
              fontSize: "12px",
              margin: "5px 0",
              color: "rgb(102, 102, 102)",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <strong>Mobile:</strong> {mobile}
          </p>
        </div>
        <div className="barcode">
          <img
            src={qrData}
            alt="Profile"
            X
            style={{
              width: 100,
              marginTop: "10px",
              marginBottom: "10px",
            }}
          />
        </div>
        <div
          className="footer"
          style={{
            background: "green",
            color: "white",
            padding: "5px",
            fontSize: "12px",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
          }}
        >
          <p>Ph: {schoolMobile}</p>
          <p>{schoolAddress}</p>
        </div>
      </div>
    </div>
  );
};

export default Card1;
